import { checkPointService } from 'src/modules/Distances/components/shared/Steps/GPX/services';
import { getDistanceId } from 'src/modules/Distances/utils';

export const loadCheckPoints = async () => {
  const distanceId = getDistanceId() || 0;
  checkPointService.loadCheckPoints(distanceId);
};
